<div [formGroup]="sendFileDetailsForm">
  @if (sendFormService.sendFormConfig.mode === "edit") {
    <div class="bv-send-file-summary">
      <div bitTypography="body2" class="tw-text-muted">{{ "file" | i18n }}</div>
      <div class="tw-text-wrap tw-break-all" data-testid="file-name">
        {{ sendFormService.originalSendView()?.file.fileName }}
      </div>
      <div data-testid="file-size" class="tw-text-muted">
        {{ sendFormService.originalSendView()?.file.sizeName }}
      </div>
    </div>
  } @else {
    <div
      class="bv-send-file-dropzone"
      role="button"
      tabindex="0"
      (click)="fileSelector.click()"
      (keydown.enter)="fileSelector.click()"
      (keydown.space)="fileSelector.click(); $event.preventDefault()"
    >
      <div class="bv-send-file-dropzone__icon" aria-hidden="true"></div>
      <p class="bv-send-file-dropzone__title">{{ "bvSendFileDropTitle" | i18n }}</p>
      <p class="bv-send-file-dropzone__hint">{{ "bvSendFileDropHint" | i18n }}</p>
      <button
        bitButton
        type="button"
        buttonType="secondary"
        class="bv-send-file-dropzone__browse"
        (click)="fileSelector.click(); $event.stopPropagation()"
      >
        {{ "chooseFile" | i18n }}
      </button>
      @if (fileName()) {
        <p class="bv-send-file-dropzone__filename">{{ fileName() }}</p>
      }
    </div>
    <input
      bitInput
      #fileSelector
      type="file"
      formControlName="file"
      hidden
      (change)="onFileSelected($event)"
    />
  }
</div>
